import selectShortcutsOption from '../data/mutators/selectShortcutsOption';
import KeyboardShortcutsViewState from '../data/store/schema/KeyboardShortcutsViewState';
import getKeyboardShortcutsOptions from '../data/store/store';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { lazySetIsHotkeysMapVisible } from 'owa-hotkeys-map';
import { OptionDescription } from 'owa-options-controls';
import { getFallbackValueIfNull } from 'owa-options-core';
import KeyboardShortcutsMode from 'owa-service/lib/contract/KeyboardShortcutsMode';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const styles = require('./KeyboardShortcutsFull.scss');

export interface KeyboardShortcutsFullProps {
    userOptions?: UserOptionsType;
    optionState?: KeyboardShortcutsViewState;
}

@reactive({
    userOptions: () => getUserConfiguration().UserOptions,
    optionState: () => getKeyboardShortcutsOptions(),
})
export default class KeyboardShortcutsFull extends React.Component<KeyboardShortcutsFullProps, {}> {
    render() {
        let { userOptions, optionState } = this.props;

        let selectedKey = `${getFallbackValueIfNull(
            optionState.shortcuts,
            userOptions.KeyboardShortcutsMode
        )}`;

        return (
            <div>
                <OptionDescription>{strings.options_shortcuts_description}</OptionDescription>
                <ChoiceGroup
                    label={strings.options_shortcuts_label}
                    selectedKey={selectedKey}
                    options={[
                        {
                            key: `${KeyboardShortcutsMode.Hotmail}`,
                            text: strings.options_shortcut_choice_hotmail,
                        },
                        {
                            key: `${KeyboardShortcutsMode.Yahoo}`,
                            text: strings.options_shortcut_choice_yahoo,
                        },
                        {
                            key: `${KeyboardShortcutsMode.Gmail}`,
                            text: strings.options_shortcut_choice_gmail,
                        },
                        {
                            key: `${KeyboardShortcutsMode.Owa}`,
                            text: strings.options_shortcut_choice_outlook,
                        },
                        {
                            key: `${KeyboardShortcutsMode.Off}`,
                            text: strings.options_shortcut_choice_off,
                        },
                    ]}
                    onChange={this.onChange}
                />
                {/* Show the link to open keyboard shortcuts map if shortcuts are enabled. */}
                {userOptions.KeyboardShortcutsMode !== KeyboardShortcutsMode.Off && (
                    <div className={styles.fullListCta}>
                        <span>{strings.options_shortcut_cta_shorcuts}</span>
                        <Link
                            aria-label={strings.options_shortcut_cta_shorcuts_click_aria}
                            onClick={() => {
                                lazySetIsHotkeysMapVisible.importAndExecute(true);
                            }}>
                            {strings.options_shortcut_cta_shorcuts_click}
                        </Link>
                    </div>
                )}
            </div>
        );
    }

    private onChange(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) {
        selectShortcutsOption(parseInt(option.key, 10) as KeyboardShortcutsMode);
    }
}
